
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow flex items-center justify-center py-24">
        <div className="container-custom">
          <div className="max-w-md mx-auto text-center">
            <div className="bg-plumbing-100 rounded-full w-24 h-24 flex items-center justify-center mx-auto mb-6">
              <span className="text-5xl font-bold text-plumbing-600">404</span>
            </div>
            
            <h1 className="text-3xl font-bold mb-4">Page Not Found</h1>
            <p className="text-gray-600 mb-8">
              We're sorry, but the page you're looking for doesn't exist or has been moved.
            </p>
            
            <a href="/" className="cta-button inline-flex">
              <Home size={20} className="mr-2" />
              Return to Homepage
            </a>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
